// Booking related constants
import {EBAC_SUPPORT_PHONE_NUMBER, SIR_SUPPORT_PHONE_NUMBER} from "@shared/constants";

export const ADD_OFFER_CODE = 'Add Offer Code'
export const AVAILABLE_BALANCE = 'Available Balance'
export const BONUS_TIME_GUEST_DISCLAIMER_BUTTON = 'Got it'
export const BONUS_TIME_GUEST_DISCLAIMER_TEXT = 'Bonus time is not available with guest check-in.'
export const BOOK = 'Book'
export const BOOK_NOW = 'Book Now'
export const CALL_TO_BOOK = 'Call to book 866-272-1286'
export const BOOK_PHONE_NUMBER = '866-272-1286'
export const BORROW_AND_PURCHASE_HOUSEKEEPING_DETAILS = 'Borrow and purchase housekeeping details'
export const CANCEL_REMOVE_POINTS_PROTECTION_CTA = 'No, keep points protection'
export const CANCELLATION_POLICY_BUTTON_TEXT = 'Cancellation Policy'
export const CANCELLATION_POLICY_HELP_TEXT = 'If plans change, cancelling is easy.'
export const CONFIRM_REMOVE_POINTS_PROTECTION_MESSAGE =
  'Without protection, canceling or changing your reservation could result in losing your points. With Points Protection, you can cancel or modify your vacation up until check-in day without losing any points.'
export const CONFIRM_REMOVE_POINTS_PROTECTION_CTA = 'Yes, remove points protection'
export const CONFIRM_REMOVE_POINTS_PROTECTION_DIALOG_HEADER = 'You are removing points protection'
export const CANCEL_REMOVE_CREDITS_PROTECTION_CTA = 'No, keep Credit Protection'
export const CONFIRM_REMOVE_CREDITS_PROTECTION_MESSAGE =
  'Without protection, canceling or changing your reservation could result in losing your credits. With Credit Protection, you can cancel or modify your vacation up until check-in day without losing your credits.'
export const CONFIRM_REMOVE_CREDITS_PROTECTION_CTA = 'Yes, remove Credit Protection'
export const CONFIRM_REMOVE_CREDITS_PROTECTION_DIALOG_HEADER = 'You are removing Credit Protection'
export const CREDITS_BORROWED = 'Credits Borrowed'
export const CREDIT_CARD_DETAILS_REQUIRED_MESSAGE = 'Please fill in all credit card details to continue.'
export const CREDIT_PROTECTION = 'Credit Protection'
export const COMPLETE_BOOKING_CREDITS_PROTECTION_TITLE = 'Credit Protection'
export const CREDIT_PROTECTION_CONTENT = [
  'The unexpected is never planned, but you have a way to protect your credits with Credit Protection.',
  'Cancel a reservation after your cancellation date and prior to check-in without losing your credits.',
  'Can be added to a new or existing reservation.',
  'Deliver new experiences and give you quality time with the people you love.',
  'Credit Protection is a one-time purchase (non-refundable and non-transferable) that allows you to avoid a penalty of credits should you need to cancel your WorldMark reservation after the cancellation date.',
  'Credit Protection can be added to a new or existing reservation.',
]
export const CREDIT_PROTECTION_TERMS_AND_CONDITIONS_CONTENT = [
  'Credit Protection Terms & Conditions: When Credit Protection is purchased, it allows you to cancel your reservation without forfeiting your credits up until the day of check-in. Credit Protection may be added to your reservation up to 15 days prior to check-in and may not be added to reservations confirmed with Charitable Gift, WYNDHAM® Club Pass or Plus Partners travel. Additional terms may apply.',
  'For Wyndham Extra Holidays owner reservations, Credit Protection only protects credits if the entire vacation was not rented; credits will not be returned for partial rentals.',
  'Credit Protection is only eligible for reservations that involve the personal occupancy and use of an owner or an owner\'s immediate family ("Permitted Users") and for no other purpose including "Commercial Use."',
  'Commercial Use includes, but is not limited to, reserving an accommodation for anyone other than a Permitted User as a regular practice for business, speculative, investment or other similar purposes, or use by an owner of public advertising or an online website to seek renters or other non-Permitted Users. Reservations that are deemed "Commercial Use" are ineligible for Credit Protection coverage. Should a reservation identified as Commercial Use have Credit Protection coverage, the owner will not receive a refund for any credits, reservation transactions, Housekeeping service, or monies used to reserve that reservation if cancelled outside of the Standard Cancellation Window.',
]
export const EDIT = 'Edit'
export const EXTRA_POINTS_REQUIRED = 'Extra Points Required'
export const GUEST_ALLOWANCES_MESSAGE = 'You have used all your guest allowances. Only an owner can check in during this time.'
export const GUEST_CONFIRMATION = 'Guest Confirmation'
export const GUEST_CONFIRMATION_BALANCE = 'Guest Confirmation Balance'
export const GUEST_CONFIRMATION_NEEDED = 'Guest Confirmation Needed'
export const GUEST_CERTIFICATES = 'Guest Certificates'
export const GUEST_CERTIFICATES_BALANCE = 'Guest Certificates balance'
export const GUEST_CERTIFICATES_NEEDED = 'Guest Certificates needed'
export const PURCHASE_GUEST_CERTIFICATES = 'Purchase Guest Certificates'
export const GUEST_DISCLAIMER = 'Only one person can check in. If your guest isn’t checking in, there’s no need to add them.'
export const GUEST_DISCLAIMER_BUTTON = 'Got it'
export const GUEST_DISCLAIMER_TEXT = 'Guest check-in is not available with your current membership.'
export const GUEST_REQUIRED_INFO_MESSAGE = 'Please fill in all required guest information to continue.'
export const HIDE_ADDRESS_INFO = 'Hide Address Information'
export const HOUSEKEEPING = 'Housekeeping'
export const HOUSEKEEPING_BALANCE = 'Housekeeping balance'
export const HOUSEKEEPING_MODAL_BODY_SECTIONS: ReadonlyArray<{ heading: string; paragraph: string }> = [
  {
    heading: 'Borrow housekeeping services',
    paragraph:
      'Your housekeeping services renew on your anniversary. To complete this reservation, you can borrow housekeeping services from next year. If you need to cancel your reservation, housekeeping services will be returned to their original year.',
  },
  {
    heading: 'Purchase housekeeping services',
    paragraph:
      "Housekeeping fees are based on the suite type you've selected. In the case of cancellation, housekeeping fees are fully refundable. You can view your housekeeping fee on the \"Review & Pay\" step.",
  },
]
export const HOUSEKEEPING_MODAL_CONTENT =
  '<p><strong>Borrow housekeeping services</strong></p>' +
  '<p>Your housekeeping services renew on your anniversary. To complete this reservation, you can borrow housekeeping services from next year. If you need to cancel your reservation, housekeeping services will be returned to their original year.</p>' +
  '<p><strong>Purchase housekeeping services</strong></p>' +
  '<p>Housekeeping fees are based on the suite type you\'ve selected. In the case of cancellation, housekeeping fees are fully refundable. You can view your housekeeping fee on the "Review & Pay" step.</p>'
export const HOUSEKEEPING_MODAL_HEADER = 'Borrowing and Purchasing Housekeeping Services'
export const HOUSEKEEPING_NEEDED = 'Housekeeping needed'
export const INVALID_PHONE_NUMBER_MESSAGE = 'Phone number is required and invalid'
export const LEARN_ABOUT_PAYMENT_OPTIONS_LABEL = 'Learn about payment options'
export const LEARN_ABOUT_RENTAL_OPTIONS_LABEL = 'Learn about rental options'
export const LESS_OPTIONS = 'Less Options'
export const MAX_RENTAL_POINTS_NOTE = (maxRentalPoints: number | string): string => `You can rent up to ${maxRentalPoints} points for a small fee.`
export const MEMBERSHIP_CHARGES = 'Membership Charges'
export const MORE_OPTIONS = 'More Options'
export const ORIGINAL_DATES = 'Original Dates'
export const OVERLAPPING_RESERVATION_MESSAGE =
  'You have overlapping reservation dates for the selected traveler. You must change the traveler on one of your reservations within 48 hours or this reservation will be automatically canceled.'
export const OVERLAPPING_RESERVATION_SAME_TRAVELER_MESSAGE =
  'This reservation breaks the Multiple Reservation guideline. To proceed with this reservation a new guest name must be added.'
export const PAY_WITH_CREDITS_LABEL = 'Pay with Credits'
export const PAY_WITH_PAYPAL = 'Pay with PayPal'
export const PAY_WITH_RENTAL_OPTIONS_LABEL = 'Pay with Rental Option'
export const PAYMENT_CHARGES = 'Payment Charges'
export const COMPLETE_BOOKING_PAYMENT_METHOD_HEADING = 'Payment method'
export const POINTS = 'Points'
export const POINTS_NEEDED = 'Points Needed'
export const POINTS_PROTECTION = 'Points Protection'
export const POINTS_PROTECTION_CONTENT = [
  'Points protection is a feature that allows you to protect your points in case of cancellation or modification of reservation.',
  'By opting in, you will be able to cancel or modify your vacation and keep your points for future use.',
]
export const POINTS_PROTECTION_COMPLETE_BOOKING_INTRO =
  'Points protection helps protect your points if you cancel or change your reservation. By opting in, you can cancel or modify your vacation and keep your points for future use.'
export const POINTS_RENTAL_COST = 'Points rental cost'
export const PURCHASE_GUEST_CONFIRMATION = 'Club Pass guest fee'
export const PURCHASE_HOUSEKEEPING = 'Purchase Housekeeping'
export const RATE_PER_1000_POINTS = 'Rate per 1,000 Points'
export const RATE_PER_CREDIT = 'Rate Per Credit'
export const RATE_PER_POINT = 'Rate Per Point'
export const REQUIRED = 'Required'
export const RENT_POINTS = 'Rent Points'
export const RENTAL_NIGHTLY_MINIMUM = 'Rental Nightly Minimum'
export const RESERVATION_DETAILS = 'Reservation Details'
export const RESORT_ALERTS_APPLY_MESSAGE = 'Resort alerts apply for these dates.'
export const VIEW_ALERTS = 'View Alerts'
export const SHOW_ADDRESS_INFO = 'Show Address Information'
export const SLIDER_STEP = 10 // this may need to be more dynamic based on values...
export const TOTAL_PAYMENT_DUE = 'Total Payment Due'
export const VACATION_BOOKING_PATH = 'book'
export const MK_BOOK_PATH = '/stays/book'
export const UNCHANGED_VALUES_MESSAGE = 'No changes were made to your reservation.'
export const VACATION_CREDITS = 'Vacation Credits'
export const VALID_PAYMENT_METHOD_REQUIRED_MESSAGE = 'Please select a valid payment method to continue.'
export const WHAT_IS_BONUS_TIME = 'What is Bonus Time?'
export const WHAT_IS_CREDIT_PROTECTION = 'What is Credit Protection?'
export const COMPLETE_BOOKING_WHAT_IS_CREDITS_PROTECTION = 'What is Credit Protection?'
export const WHAT_IS_POINTS_PROTECTION = 'What is Points Protection?'
export const WHO_IS_CHECKING_IN = 'Who is checking in?'
export const WHY_CANT_I_USE_BONUS_TIME_CONTENT =
  '<p>Arcu odio ut sem nulla pharetra. Dolor magna eget est lorem ipsum dolor sit amet consectetur. Aliquet porttitor lacus luctus accumsan tortor posuere. Sed nisi lacus sed viverra tellus in hac habitasse platea. Natoque penatibus et magnis dis parturient montes nascetur ridiculus. Viverra ipsum nunc aliquet bibendum enim facilisis gravida neque.</p>'
export const WHY_CANT_I_USE_BONUS_TIME_LABEL = "Why can't I use Bonus Time?"
export const TERMS_AND_CONDITIONS = 'Terms & Conditions'
export const TRIP_BOOKING_CONFIRMATION_TITLE = 'Trip booked. Game on.'
export const TRIP_BOOKING_CONFIRMATION_SUBTITLE = (resortName: string, email: string) =>
  `Get ready to check in and stay legendary at ${resortName}. A confirmation email will be sent to ${email}.`
export const RESORT_IMAGE_ALT = 'Resort Image'
export const ERROR_COMPLETING_YOUR_BOOK = 'There was an issue completing your booking. Please review the errors and try again.'
export const PAYMENT_ERROR_SUBSTRINGS = ['cc tokenization', 'payment', 'authorization', 'transaction']
export const PAYMENT_FAILED_MESSAGE = (brand: string) => {
  const mainText = 'Payment failed. Please check your details and try again. Contact support at'
  if (brand === 'sir' || brand === 'cw') {
    return `${mainText} ${SIR_SUPPORT_PHONE_NUMBER} if the issue persists.`
  }
  return `${mainText} ${EBAC_SUPPORT_PHONE_NUMBER} if the issue persists.`
}
export const UNEXPECTED_ERROR_OCCURRED = 'An unexpected error occurred. Please try again later.'
export const CHECKIN_GUEST_SELECTED = 'guest'
export const CHECKIN_OWNER_SELECTED = 'owner'
export const CANCELLATION_NOTE_BEFORE_PENALTY_WM = (cancellationDeadline: string) =>
  `Cancel by ${cancellationDeadline} to avoid penalty (Guest Certificates and Guest Certificate fees are non-refundable).`
export const CANCELLATION_NOTE_CW = `If plans change, cancelling is easy.`
export const CANCELLATION_NOTE_AFTER_PENALTY = 'This reservation has passed the cancellation date and will be penalized if cancelled.'

// Resort Suite Dialog constants
export const MAX_OCCUPANCY = 'Max Guests:'
export const ROOM_AMENITIES = 'Room Amenities'
export const ROOM_AMENITIES_NOTE = 'Amenities may differ from suite to suite.'
export const ACCESSIBLE_FEATURES = 'Accessible Features'
export const GUARANTEED_ACCESSIBLE_FEATURES = 'Guaranteed Accessible Features'
export const NON_GUARANTEED_ACCESSIBLE_FEATURES = 'Non-Guaranteed Accessible Features'
export const FLOOR_PLAN = 'Floor Plan'
export const PRICE_BREAKDOWN = 'Price Breakdown'
export const PRICE_BREAKDOWN_TOTAL = 'Total points'
export const CHECKOUT = 'Checkout'
export const VIP_MEMBER_NOTE = 'Our VIP Program provides special benefits to our Members who have 300,000 points or more.'
export const POINTS_TOTAL = 'points total'
export const LEARN_MORE_MEMBERSHIP = 'Learn More'

export const GUEST_CONFIRMATION_COST_ID = 'guest-confirmation'
export const CLUB_PASS_GUEST_FEE_COST_ID = 'guest-certificate-fee'
export const CLUB_PASS_EXCHANGE_FEE_COST_ID = 'purchase-guest-confirmation'
export const CLUB_PASS_GUEST_FEE_PAYMENT_COST_ID = 'purchase-guest-confirmation'
export const CLUB_PASS_GUEST_FEE_DISCLAIMER = (brand: string) => {
  switch (brand) {
    case 'ebac':
      return 'In order to have a guest check-in with your Eddie Bauer adventure club membership, you will need to purchase a Club Pass guest fee.'
    default:
      return 'In order to have a guest check-in with your membership, you will need to purchase a Club Pass guest fee.'
  }
}

export const CostIds = Object.freeze({
  HOUSEKEEPING_CHARGE_BORROW: 'housekeeping-charge-borrow',
  VACATION_CREDITS_BORROW: 'vacation-credits-borrow',
  FUTURE_HOUSEKEEPING_CREDITS: 'future-housekeeping-credits',
  HOUSEKEEPING_RENTAL: 'housekeeping-rental',
  PURCHASE_HOUSEKEEPING_CREDITS: 'purchase-housekeeping-credits',
  BORROW_HOUSEKEEPING_CREDITS: 'borrow-housekeeping-credits',
  PROTECTION_FEE: 'protection-fee',
})

export const BalanceIds = Object.freeze({
  CREDITS: 'credits',
  POINTS: 'points',
  RENTAL_LIMIT: 'rentalLimit',
  GUEST_ALLOWANCES: 'guestAllowances',
  HOUSEKEEPING_CREDITS: 'houseKeepingCredits',
})

export const GUEST_CONFIRMATION_PURCHASE_DISCLAIMER = (brand: string) => {
  switch (brand) {
    case 'sir':
      return 'In order to have a guest check-in with your Sports Illustrated membership, you will need to purchase a Guest Confirmation Credit.'
    case 'ebac':
      return 'In order to have a guest check-in with your Eddie Bauer Adventure Club membership, you will need to purchase a Guest Certificate.'
    default:
      return 'In order to have a guest check-in with your membership, you will need to purchase a Guest Confirmation.'
  }
}

// Catalog routes moved to catalog module
// export const CATALOG_HOME_PATH = '/mako/catalog'  // MIGRATED to catalog/index.ts
